module.exports = __webpack_public_path__ + "static/media/codexplus-toolbox-guide.f8d7743f.png";